module.exports = __webpack_public_path__ + "img/man-time-phone.27fe5dbf.svg";